import { Component, type ErrorInfo, type ReactNode } from 'react';
import { track } from '../lib/analytics';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[ErrorBoundary]', error);
    console.error('[ErrorBoundary stack]', error?.stack);
    console.error('[ErrorBoundary componentStack]', errorInfo.componentStack);
    try {
      track('error', {
        message: error.message,
        name: error.name,
        componentStack: errorInfo.componentStack,
      });
    } catch {
      // ignore analytics failure
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            background: 'var(--bg-color, #1a1a1a)',
            color: 'var(--text-color, #fff)',
            fontFamily: 'system-ui, sans-serif',
            textAlign: 'center',
          }}
        >
          <h2 style={{ fontSize: '1.25rem', marginBottom: 8 }}>Что-то пошло не так</h2>
          <p style={{ fontSize: '0.875rem', color: 'var(--hint_color, rgba(255,255,255,0.6))', marginBottom: 24 }}>
            Мы уже получили данные об ошибке. Попробуйте перезагрузить приложение.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: '12px 24px',
              borderRadius: 12,
              border: 'none',
              background: 'var(--button_color, #7850ff)',
              color: 'var(--button_text_color, #fff)',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Перезагрузить
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
